package com.trevorwiebe.timesheet.admin.loadrate.presentation

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRate
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateCategory
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateType
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateUnit
import com.trevorwiebe.timesheet.mileage.domain.model.Location

@Composable
actual fun AddEditLoadRateDialog(
    editing: LoadRate?,
    locations: List<Location>,
    onDismiss: () -> Unit,
    onSave: (
        LoadRateCategory,
        LoadRateType,
        LoadRateUnit?,
        perUnitText: String,
        flatRateText: String,
        pickupLocationId: String,
        dropLocationId: String,
    ) -> Unit,
) {
    Dialog(onDismissRequest = onDismiss) {
        Card(shape = RoundedCornerShape(16.dp)) {
            Column(modifier = Modifier.padding(vertical = 16.dp)) {
                AddEditLoadRateFormContent(
                    editing = editing,
                    locations = locations,
                    onDismiss = onDismiss,
                    onSave = onSave
                )
            }
        }
    }
}
